export default (that, disabled) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    slots: { default: 'defaultImageUrl' },
  },
  {
    visible: !disabled,
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 85,
    fixed: 'right',
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'materialNo',
    align: 'left',
    headerAlign: 'center',
    minWidth: 180,
    title: that.$l('table_label_fabric_no') || '面料编号',
    showHeaderOverflow: 'title',
    slots: { default: 'materialNoInfo' },
  },
  {
    field: 'materialName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 230,
    title: that.$l('table_label_fabric_name') || '面料名称',
    showHeaderOverflow: 'title',
    slots: { default: 'materialNameInfo' },
  },
  {
    field: 'displayName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 260,
    title: that.$l('table_label_display_name') || '属性描述',
    showHeaderOverflow: 'title',
    slots: { default: 'displayNameInfo' },
  },
  {
    field: 'metadataDesc',
    align: 'left',
    headerAlign: 'center',
    minWidth: 150,
    title: that.$l('table_label_attribute_desc') || '属性说明',
    showHeaderOverflow: 'title',
  },
]
